// 同时支持桌面和移动端的拖拽
export const draggable = {
  name: 'draggable',
  option: {
    bind(el, binding, vnode) {
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;
      const threshold = 5; // 拖拽与点击的区分阈值
      const vm = vnode.context;

      const getTouchEvent = event => {
        // 获取 touch 事件的第一个触点，兼容 PC 和移动端
        return event.touches && event.touches[0] ? event.touches[0] : event;
      };

      const onStart = event => {
        // 获取触摸事件（兼容 PC 和移动端）
        const touch = getTouchEvent(event);

        // 记录触摸起点
        startX = touch.clientX;
        startY = touch.clientY;

        // 获取元素的当前位置信息
        const style = window.getComputedStyle(el);
        startLeft = parseInt(style.left || 0, 10);
        startTop = parseInt(style.top || 0, 10);

        // 初始化拖拽状态
        vm.isDragging = false;

        // 注册全局事件
        document.addEventListener('mousemove', onMove, { passive: false });
        document.addEventListener('mouseup', onEnd, { passive: false });
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd, { passive: false });
      };

      const onMove = event => {
        // 获取触摸点位置
        const touch = getTouchEvent(event);
        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;

        // 如果移动距离超过阈值，视为拖拽
        if (Math.abs(deltaX) > threshold || Math.abs(deltaY) > threshold) {
          vm.isDragging = true;
        }

        if (vm.isDragging) {
          event.preventDefault();

          // 计算移动后的新位置
          let newLeft = startLeft + deltaX;
          let newTop = startTop + deltaY;

          // 限制元素不能超出屏幕范围
          const elWidth = el.offsetWidth;
          const elHeight = el.offsetHeight;
          const maxLeft = window.innerWidth - elWidth;
          const maxTop = window.innerHeight - elHeight;

          newLeft = Math.max(0, Math.min(newLeft, maxLeft));
          newTop = Math.max(0, Math.min(newTop, maxTop));

          // 设置元素的新位置
          el.style.left = `${newLeft}px`;
          el.style.top = `${newTop}px`;
        }
      };

      const onEnd = () => {
        // 解除全局事件（PC 和移动端）
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      };

      // 绑定事件（同时支持鼠标事件和触摸事件）
      el.addEventListener('mousedown', onStart);
      el.addEventListener('touchstart', onStart, { passive: false });
    }
  }
};
